// 忘记密码页面
import React, {FunctionComponent, useState, useEffect, useMemo, Fragment, useCallback} from "react";
// @ts-ignore
import {JSEncrypt} from "encryptlong"; //引用
// @ts-ignore
import {connect} from "react-redux";
import ReactDOM from "react-dom";
import Grid from "@material-ui/core/Grid";
import ParaSteps from "../../components/ParaUI/ParaSteps";
import {API_CONFIG} from "../../config/api.config";
import {Post, Get, GetParamByName, GetHost} from "para-lib";
import {message} from "para-ui";
import API from "../../config/api.config";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ParaPasswordPolicy from "../personCenter/ParaPasswordPolicy";
import {Controller, useForm} from "react-hook-form";
import EmailIcon from "../../svgs/EmailIcon";
import PhoneIcon from "../../svgs/PhoneIcon";
import SecurityIcon from "../../svgs/SecurityIcon";
import TextFieldMui from "@material-ui/core/TextField";
import Countdown from "../../components/ParaUI/Countdown";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import "./index.scss";
import "../../styles/styles.scss";
import "./style/styles-5.6.4.scss";
import "./style/index.scss";
import CodeValidate from "./components/CodeValidate";
import {checkExistUserName} from "./services";
import {queryAllValid} from '../../services/commonService';

interface PersonalCenterProps {
    userInfo?: any;
    step?: any;
}


/** 页面表单值 **/
interface StateProps {
    /** 帐号 **/
    name: FieldProps;
    /** 验证码 **/
    captcha: CaptchaFieldProps;
}

/** 表单项 **/
interface FieldProps {
    /** 值 **/
    value: string;
    /** 是否点击过 **/
    touched: boolean;
}

/** 表单项 **/
interface CaptchaFieldProps {
    /** 值 **/
    value: boolean;
    /** 是否点击过 **/
    touched: boolean;
}


/** 组件参数说明 **/
interface Props {
    /** 校验成功后的方法 **/
    successCallback: Function;
    /** 重置校验状态 **/
    refresh: number;
    /** 国际化 **/
    intl: Function;
}

/** 找回方式参数 **/
interface TypeObjProps {
    /** 用户名 **/
    uid?: string;
    /** 找回方式 **/
    restType?: string;
    /** 类型列表 **/
    typeList?: TypeListProps[];

}

/** 找回方式对应的类型列表 **/
interface TypeListProps {
    /** 内容 **/
    content: string;
    /** 类型 **/
    type: string;
}

interface IFormInput {
    [key: string]: any
}

const sendRequest = {
    url: API_CONFIG.sendMsg,
    ctx: API.PROJECTMAPPING.PORTAL
};
const defaultUser = require("../../assets/Avatar.png");
/** 创建加密对象实例 **/
const encryptor = new JSEncrypt();
const ForgetPassword: FunctionComponent<PersonalCenterProps> = (props) => {
    //const {formatMessage: intl} = useIntl();   // 国际化方法
    //const {successCallback, refresh, intl} = props;
    /** 表单数据 **/
    const [state, setState] = useState<StateProps>({
        name: {
            value: "",
            touched: false
        },
        captcha: {
            value: false,
            touched: false
        }
    });

    /** 当前步数 **/
    const [activeStep, setActiveStep] = useState<number>(0);
    /** 0 是处于输密码阶段  1 是 选择找回方式    这两个都是第一步的 **/
    const [stepOneStatus, setStepOneStatus] = useState<number>(0);
    /** 选中的找回密码的方式 **/
    const [checkedResetType, setCheckedResetType] = useState<TypeObjProps>({});
    /** 刷新数据 **/
    const [refresh, setRefresh] = useState<number>(0);
    /** 刷新标记 **/
    const [refreshCode, setRefreshCode] = useState<number>(0);
    /**
     * 更新图形验证码的值
     * @param valid 验证码是否通过
     */
    const handleCodeValidateCallback = (valid: boolean) => {
        setState((pre: StateProps) => {
            pre.captcha.value = valid;
            pre.captcha.touched = true;
            return {...pre};
        });
    };
    /* 下一步的步骤数 */
    const logoimg = require("../../assets/para-icon.png");
    const paraimg = require("../../assets/portal-logo.png");
    const [step, setStep] = React.useState<number>(0);
    const [touched, setTouched] = React.useState<boolean>(false);
    const [resetTypes, setResetTypes] = React.useState<any>([]);
    const [userName, setUserName] = React.useState<any>(); // 当前的用户名
    const [disableSubmitBtn, setDisableSubmitBtn] = React.useState<boolean>(true); // 第三步的提交按钮
    const [selectedType, setSelectedType] = React.useState<any>(null); // 已选的找回密码的方式
    const [showPassword, setShowPassword] = React.useState({
        newpassword: false, // 新密码
        newpasswordCopy: false // 确认密码
    });
    const [param, setParam] = React.useState<any>({
        messageType: selectedType?.type, username: userName
    });
    const {
        register,
        control,
        handleSubmit,
        errors,
        getValues,
        setValue,
        reset,
        setError,
        clearErrors
    } = useForm<IFormInput>({});
    /** 公钥对应的id **/
    const [publicKeyId, setPublicKeyId] = React.useState<string>('');

    /**
     * 获取publicKeyId 公钥 并且保存公钥对应的id
     */
    const getPublicKeyId = useCallback(async () => {
        const {err, data} = await queryAllValid();
        if(err) return;
        const {publicKeyId, publicKey} = data?.data?.param;
        setPublicKeyId(publicKeyId || '');
        encryptor.setPublicKey(publicKey);
    }, [])

    useEffect(() => {
        getPublicKeyId();
    }, [])

    // 步骤条文本提示
    // 输入帐号 选择找回方式 密码重设 完成
    const STEP_INIT = React.useMemo(() => ["输入帐号", "选择重置方式", "密码重置", "完成"], []);

    const RESET_TYPE = React.useMemo(() => [
        {
            title: "短信", // 短信
            label: "手机号", // 手机号
            bind: false,
            icon: <PhoneIcon/>,
            content: "",
            type: "SMS"
        },
        {
            title: "邮箱", // 邮箱
            label: "邮箱", // 邮箱
            bind: false,
            icon: <EmailIcon/>,
            content: "",
            type: "Email"
        },
        {
            title: "密保问题", // 密保问题
            bind: false,
            icon: <SecurityIcon/>,
            content: "",
            type: "Question"
        }
    ], []);

    const changeShowPassword = (name: string) => {
        setShowPassword((pre: any) => {
            pre[name] = !pre[name];
            return {...pre};
        });
    };


    // 获取找回密码的方式
    const getResetType = async (user: string, code: boolean) => {
        //setUserName(user);
        let param = {
            userName: user,
            resourceType: 2,
            code
        };
        const {data, err} = await checkExistUserName(param);
        // const {data, err} = await Post({
        //     url: API_CONFIG.resetTypeByCode,
        //     params : param,
        //     ctx: API.PROJECTMAPPING.PORTAL
        // });

        /* 接口报错时，给出提示 2020-09-05 cxl */
        //if (err) return;
        if (err) {
            message.warning(data?.data || data?.msg);
            // setRefreshCode(Math.random());
            setRefresh(Math.random());
            return;
        }

        if (data.code === "0") {
            let result = data.data.map((item: any) => ({
                type: item.type,
                provider: item.content
            }));
            RESET_TYPE.forEach((item: any) => {
                item.bind = false;
            });
            result.forEach((res: any) => {
                RESET_TYPE.forEach((item: any) => {
                    if (item.type === res.type) {
                        item.bind = true;
                        item.content = res.provider;
                    }
                });
            });
            setResetTypes(RESET_TYPE);
            // 接口成功在切换步数
            setStep(1);
        } else {
            message.warning(data?.data || data?.msg);
            //Message.warn(data?.data || data?.msg);
            setRefresh(Math.random());
            // setRefreshCode(Math.random());
            // 校验不通过 要重置 code
            /* 用户名不存在，加个上一步按钮返回 2020-09-05 cxl */
            // ReactDOM.render(
            //     <button type='reset' className={"back-btn"}
            //             onClick={() => setStep(0)}>
            //         {/*上一步*/}
            //         上一步
            //     </button>,
            //     document.getElementById("steps-two")
            // );
        }
    };

    /** 验证码dom **/
    const codeValidateRender = React.useMemo(() => {
        return <CodeValidate key={refreshCode} username={userName}
                             callback={handleCodeValidateCallback}/>;
    }, [refreshCode, state, userName]);

    /** 重置验证码之后要 清空验证码的值 **/
    useEffect(() => {
        setState((pre: StateProps) => {
            pre.captcha.value = false;
            return {...pre};
        });
    }, [refreshCode]);

    /** 监听刷新 **/
    useEffect(() => {
        setRefreshCode(refresh);
    }, [refresh]);
    // 选择了某种找回方式
    const selectAWay = (item: any) => {
        if (item.type === "Question") {
            getQuestionList(item);
        } else {
            setSelectedType(item);
            setDisableSubmitBtn(true);
            setParam({...param, messageType: item?.type});
            setStep(2);
        }
    };

    // 获取密保问题
    const getQuestionList = async (item: any) => {
        const {data, err} = await Get({
            url: API_CONFIG.securityQus,
            ctx: API.PROJECTMAPPING.PORTAL
        });
        if (err) return;
        if (data.code == 0) {
            data.data.forEach((ques: any) => {
                if (ques.key === item.content) {
                    item.desc = ques.content;
                    item.securityKey = ques.key;
                }
            });
            setSelectedType(item);
            setParam({...param, messageType: item?.type});
            setStep(2);
        } else {
            message.warning(data?.data || data?.msg);
        }

    };

    const handleChange = (e: any, type: string) => setValue(type, e.target.value);

    // 表单提交
    const onSubmit = async () => {
        const value = getValues();
        if (value.content.trim() === "") {
            setError("content", {type: "validate", message: "验证码不能为空白"});
            return;
        }

        if (value.newpassword !== value.newpasswordCopy) {
            message.warning("两次密码输入不一致，请检查"); // 两次密码输入不一致，请检查
            return;
        }

        let param = {
            "username": userName,
            "messageType": selectedType.type,
            "content": value.content.trim(),
            "newpassword": encryptor.encryptLong(value.newpassword),
            // "publicKeyId": publicKeyId,
            "securityKey": selectedType.securityKey
        };
        if (selectedType.type === "Question") {
            param.securityKey = selectedType.securityKey;
        }
        const {data, err} = await Post({
            url: API_CONFIG.resetPassword,
            ctx: API.PROJECTMAPPING.PORTAL
        }, param);
        if (err) return message.warning(err.message);
        if (data.code === "0" || data.code === 0) {
            setStep(3);
        } else {
            message.warning(data?.data || data?.msg);
        }
    };

    // 点击提交
    const submitDataFunction = () => {
        handleSubmit(onSubmit)();
    };

    // 密码重置成功后返回登录
    const login = () => {
        let redirectUrl = GetParamByName("redirectUrl", window.location.href);
        if (redirectUrl && redirectUrl !== '') {
            window.location.href = redirectUrl
        } else window.location.href = window.location.protocol + "//" + window.location.host + `/ngw/logout?returnurl=${window.location.href}`;
    };

    /* 键盘事件 */
    const goNext = () => {
        if (!userName) return message.warning("请输入帐号");
        setTouched(true);
        setState((pre: StateProps) => {
            pre.captcha.touched = true;
            pre.name.touched = true;
            return {...pre};
        });

        if (Boolean(!userName && state.name.touched) || Boolean(!state.captcha.value && state.captcha.touched)) {
            // 没有校验通过就不走下面的逻辑
            // return Message.warn("请先完成安全校验");
            return message.warning("请先完成安全校验");
        }
        if (!(!userName || userName === "")) {
            // setStep(1);
            setParam({...param, username: userName});
            getResetType(userName, state.captcha.value);
        }
    };

    React.useEffect(() => {
        // 在这里获取参数 判断当前是第几步

        let user = GetParamByName("username", window.location.href);
        if (user && user !== "") {
            setUserName(user);
            setParam({...param, username: user});
            // setStep(1);
            getResetType(user, state.captcha.value);
        }
    }, []);
    return (
        <div className={"portal-forget-container"}>
            <div className={"top-box"}>
                <img src={paraimg} alt=""/>
                <span>
                    {/*派拉门户*/}
                    门户管理
                </span>

                <div className={"top-right"} onClick={() => login()}>
                    <img src={defaultUser}/>
                    <span>登录</span>
                </div>
            </div>
            <div className={"center-box"}>
                <div className={"title"}>
                    <span>
                        {/*找回密码*/}
                        IAM重置密码
                    </span>
                </div>
                {/*步进器*/}
                <ParaSteps
                    value={STEP_INIT}
                    activeStep={step}
                />
                {/*第一步*/}
                {
                    step === 0 &&
                    <div className="center-wrapper">
                        <Grid container className={"step-one"}>
                            <Grid item xs={12} className={"tips-item2"}>
                                {/*输入您需要找回密码的帐号*/}
                                重置密码的帐号<span className="paraui-label-required2 ">*</span>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        {/*请输入帐号！ UID/邮箱/手机号 帐号*/}
                                        <TextFieldMui fullWidth
                                                      variant={"outlined"}
                                                      className={"zj-input"}
                                                      required
                                                      helperText={(touched && (!userName || userName === "")) && "请输入帐号！"}
                                                      error={touched && (!userName || userName === "")}
                                                      defaultValue={userName}
                                                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                          setTouched(true);
                                                          setUserName(event.target.value);
                                                      }}
                                                      onKeyUp={(e: any) => {
                                                          if (e.keyCode === 13) {
                                                              goNext();
                                                          }
                                                      }}
                                                      placeholder={"账号"}
                                            // label={userName ? "帐号" : ""}
                                        />
                                    </Grid>
                                    {/*验证码*/}
                                    <div className='new-code-box'>
                                        <div className='code-title'>验证码<span>*</span></div>
                                        {codeValidateRender}
                                    </div>
                                    {/*<TextFieldMui*/}
                                    {/*    error={Boolean(!state.captcha.value && state.captcha.touched)}*/}
                                    {/*    label={"验证码"} // 验证码*/}
                                    {/*    required={true}*/}
                                    {/*    className="no-input"*/}
                                    {/*    value={""}*/}
                                    {/*    // addonAfter={CodeValidateRender}*/}
                                    {/*/>*/}

                                    <Grid item xs={12}>
                                        <Button variant="contained" className={"primary-btn"} type='reset'
                                                color="primary" disableElevation
                                                onClick={() => goNext()}>
                                            {/*下一步*/}
                                            下一步
                                        </Button>
                                        <Button style={{margin: "8px 0 0 0"}} className={"back-btn"}
                                                onClick={() => login()}>返回</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                }
                {/*第二步*/}
                {
                    step === 1 &&
                    <div className="center-wrapper" id={"steps-two"}>
                        {/*<Grid item xs={12} className={"tips-item"} style={{textAlign: 'center'}}>*/}
                        {/*    /!*输入您需要找回密码的帐号*!/*/}
                        {/*    请选择找回方式*/}
                        {/*</Grid>*/}
                        {
                            resetTypes.map((item: any, index: number) =>
                                <Grid key={index} container className={"step-two web-step-two"} spacing={2}
                                      alignItems="center"
                                      style={{display: item.bind ? "flex" : "none"}}>
                                    <Grid item xs={1} className={"steps-two-icon"}>{item.icon}</Grid>
                                    <Grid item xs={3} className={"steps-two-mode"}>{item.title}</Grid>
                                    {/*已绑定 未绑定*/}
                                    <Grid item xs={3}
                                          className={item.bind ? "steps-two-bind" : "steps-tow-unbind"}
                                        // style={{color: item.bind ? "#0db936" : "#f63236"}}
                                    >{item.bind ? "已绑定" : "未绑定"}</Grid>
                                    <Grid item xs={4} className={"type-btn"}>
                                        <Button size={"small"} variant={"outlined"}
                                                color={"primary"}
                                                disabled={!item.bind}
                                                onClick={() => selectAWay(item)}>
                                            {/*通过 找回*/}
                                            通过{item.title}重置
                                        </Button>
                                    </Grid>
                                </Grid>)
                        }

                        {
                            resetTypes.map((item: any, index: number) =>
                                <div key={index} style={{display: item.bind ? "block" : "none"}}>
                                    <div className={"step-two step-phone-bind"}>
                                        <div className={"phone-info"}>
                                            <i>{item.icon}</i>
                                            <span>{item.content}</span>
                                        </div>
                                        <span>{item.bind ? "已绑定" : "未绑定"}</span>
                                    </div>
                                </div>
                            )
                        }

                        {/*<div className={"step-two step-phone-bind"} style={{marginBottom: '10px'}}>
                            <div className={"phone-info"}>
                                <i>{resetTypes[0].icon}</i>
                                <span>{resetTypes[0].content}</span>
                            </div>
                            <span>{resetTypes[0].bind ? "已绑定" : "未绑定"}</span>
                        </div>
                        <div className={"step-two step-email-bind"}>
                            <div className={"email-info"}>
                                <i>{resetTypes[1].icon}</i>
                                <span>{resetTypes[1].content}</span>
                            </div>
                            <span>{resetTypes[1].bind ? "已绑定" : "未绑定"}</span>
                        </div>*/}


                        <div className={"btn-box"}>
                            {resetTypes.filter((item: any) => item.bind).length <= 0 &&
                            <div className={"tips"}>未设置重置方式，请联系管理员！</div>
                            }
                            {
                                resetTypes.map((item: any, index: number) =>
                                    <div key={index} style={{display: item.bind ? "block" : "none"}}>
                                        {/*<Button color={"primary"} style={{margin: '0 0 14px'}} className={"primary-btn two-bing-btn"}*/}
                                        {/*        onClick={() => selectAWay(resetTypes[0])}>*/}
                                        {/*    /!*通过 找回*!/*/}
                                        {/*    通过短信重置*/}
                                        {/*</Button>*/}
                                        <Button color={"primary"} className={"primary-btn two-bing-btn"}
                                                onClick={() => selectAWay(item)}>
                                            {/*通过 找回*/}
                                            通过{item.title}重置
                                        </Button>
                                    </div>
                                )
                            }
                            <button type='reset' className={"back-btn"}
                                    onClick={() => {
                                        setTouched(false);
                                        setUserName("");
                                        setStep(0);
                                    }}>
                                {/*上一步*/}
                                上一步
                            </button>
                        </div>
                    </div>
                }
                {/*第三部*/}
                {
                    step === 2 &&
                    <div className="center-wrapper" style={{maxWidth: "800px"}}>
                        <Grid container spacing={2} className={"step-three"}>
                            <Grid item xs={7} className={"step-three-grid1"}>
                                <Grid container spacing={2}>
                                    {
                                        selectedType?.type === "Question" ?
                                            <Grid item xs={12} className={"tips-item"}>
                                                {/*密保问题*/}
                                                密保问题：{selectedType.desc}</Grid> :
                                            <Grid item xs={12}
                                                  className={"tips-item"}>
                                                {/*已绑定*/}
                                                已绑定{selectedType.label}：{selectedType.content}</Grid>
                                    }

                                    <Grid item xs={12}>
                                        <form className="eic-setting-form">
                                            <Grid container spacing={2}>
                                                {
                                                    selectedType?.type === "Question" ?
                                                        <Grid item xs={12}>
                                                            {/*请输入密保答案 密保答案*/}
                                                            <Controller name={"content"} control={control}
                                                                        onChange={(e: any) => handleChange(e, "content")}
                                                                        rules={{
                                                                            required: {
                                                                                value: true,
                                                                                message: "请输入密保答案"
                                                                            }
                                                                        }}
                                                                        render={props => <TextFieldMui fullWidth
                                                                                                       variant={"outlined"}
                                                                                                       className={"zj-input"}
                                                                                                       required
                                                                                                       helperText={errors?.content?.message}
                                                                                                       error={Boolean(errors.content)}
                                                                                                       ref={register}
                                                                                                       placeholder={"密保答案"}
                                                                            // label={"密保答案"}
                                                                                                       {...props}
                                                                        />
                                                                        }
                                                            />
                                                        </Grid>
                                                        :
                                                        <Grid item xs={12}>
                                                            {/*请输入验证码 验证码*/}
                                                            <Controller name={"content"} control={control}
                                                                        onChange={(e: any) => handleChange(e, "content")}
                                                                        rules={{
                                                                            required: {
                                                                                value: true,
                                                                                message: "请输入验证码"
                                                                            }
                                                                        }}
                                                                        render={props => <TextFieldMui fullWidth
                                                                                                       required
                                                                                                       variant={"outlined"}
                                                                                                       className={"zj-input code-input-box"}
                                                                                                       helperText={errors?.content?.message}
                                                                                                       error={Boolean(errors.content)}
                                                                                                       ref={register}
                                                                            // label={"验证码"}
                                                                                                       placeholder={"验证码"}
                                                                                                       {...props}
                                                                        />
                                                                        }
                                                            />
                                                            <Countdown sendRequest={sendRequest} param={param}
                                                                       callback={() => setDisableSubmitBtn(false)}/>
                                                            {/*没有点击过就不能激活确认按钮*/}
                                                        </Grid>

                                                }
                                                <Grid item xs={12}>
                                                    {/*请输入新密码*/}
                                                    <Controller name={"newpassword"} control={control}
                                                                onChange={(e: any) => handleChange(e, "newpassword")}
                                                                rules={{
                                                                    required: {
                                                                        value: true,
                                                                        message: "请输入新密码"
                                                                    }
                                                                }}
                                                                render={props => <>
                                                                    <TextFieldMui fullWidth
                                                                                  variant={"outlined"}
                                                                                  required
                                                                                  className={"zj-input"}
                                                                                  helperText={errors?.newpassword?.message}
                                                                                  error={Boolean(errors.newpassword)}
                                                                                  ref={register}
                                                                                  type={showPassword.newpassword ? "text" : "password"}
                                                                                  placeholder={"新密码"}
                                                                        // label={"新密码"}
                                                                                  {...props}
                                                                    />
                                                                    {showPassword.newpassword ?
                                                                        <Visibility className={"password-icon"}
                                                                                    onClick={() => changeShowPassword("newpassword")}/> :
                                                                        <VisibilityOff className={"password-icon"}
                                                                                       onClick={() => changeShowPassword("newpassword")}/>}

                                                                </>}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {/*请输入确认密码 确认密码*/}
                                                    <Controller name={"newpasswordCopy"} control={control}
                                                                onChange={(e: any) => handleChange(e, "newpasswordCopy")}
                                                                rules={{
                                                                    required: {
                                                                        value: true,
                                                                        message: "请输入确认密码"
                                                                    }
                                                                }}
                                                                render={props => <>
                                                                    <TextFieldMui fullWidth
                                                                                  required
                                                                                  helperText={errors?.newpasswordCopy?.message}
                                                                                  error={Boolean(errors.newpasswordCopy)}
                                                                                  ref={register}
                                                                                  type={showPassword.newpasswordCopy ? "text" : "password"}
                                                                        // label={"确认密码"}
                                                                                  variant={"outlined"}
                                                                                  placeholder={"确认密码"}
                                                                                  className={"zj-input"}
                                                                                  {...props}
                                                                    />

                                                                    {showPassword.newpasswordCopy ?
                                                                        <Visibility className={"password-icon"}
                                                                                    onClick={() => changeShowPassword("newpasswordCopy")}/> :
                                                                        <VisibilityOff className={"password-icon"}
                                                                                       onClick={() => changeShowPassword("newpasswordCopy")}/>}


                                                                </>}/>
                                                </Grid>

                                                <Grid item xs={12}
                                                      className={"step-three-surebtn"}>
                                                    <Button variant="contained" className={"primary-btn"}
                                                            disableElevation
                                                            disabled={selectedType?.type !== "Question" && disableSubmitBtn}
                                                            onClick={() => submitDataFunction()}>
                                                        {/*/!*确认*!/  选择非密保问题的找回方式 并且不可点击 才生效*/}
                                                        确认
                                                    </Button>
                                                    <Button variant="contained" type='reset' className={"back-btn"}
                                                            style={{margin: "8px 0 0 0"}} disableElevation
                                                            onClick={() => setStep(1)}>
                                                        {/*上一步*/}
                                                        上一步
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={5} className={"step-three-grid2"}>
                                <Paper variant="outlined" className={"password-rules"}>
                                    <Typography variant='body1' gutterBottom className={"rule-title"}>
                                        {/*密码规则：*/}
                                        密码规则
                                    </Typography>
                                    <ParaPasswordPolicy fullwidth={true} type={"forget"} username={userName}/>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                }
                {/*第四步*/}
                {
                    step === 3 &&
                    <div className="center-wrapper success-box">
                        <img src={logoimg}/>
                        <p>
                            {/*密码重置成功*/}
                            {selectedType?.content}密码已重置成功！
                        </p>
                        <Button className={"primary-btn"}
                                color={"primary"}
                                onClick={() => login()}>
                            {/*返回登录*/}
                            立即登录
                        </Button>


                    </div>
                }

            </div>
        </div>
    );
};

export default connect((state: { user: any }) => ({...state.user}))(ForgetPassword);
